import { LicenseIcon } from '@hugeicons/react'

import { Button } from '@/shared/ui'

import { useQuizContext } from '../../../context'

const PLAY_NAV_BUTTON_CLASS =
  'shrink-0 text-sky-500 hover:bg-sky-500 hover:text-white'

export const DigitalProductQuizQuizPlayQuestionFooterIntroButton = () => {
  const { goToPrevStep } = useQuizContext()

  return (
    <Button
      type="button"
      variant="ghost"
      icon
      className={PLAY_NAV_BUTTON_CLASS}
      leadingIcon={<LicenseIcon size={20} variant="duotone" />}
      onClick={goToPrevStep}
      aria-label="Voltar para introdução"
    />
  )
}
